import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';

import { ILogo, LogoColorVariant } from '../tron-editor-api';

import { localization } from '../../../shared/localization/localization';
import { DebuggerInstance } from 'src/App/shared/debugger';
import { ILogoVariantsInfo } from '../tron-editor-interfaces';
import { FillPicker } from './fill-picker.component';

export interface ILogoEditorLogoSettingsProps {
    logoObj: ILogo;
    variantsInfo: ILogoVariantsInfo;
    customColor: string;
    recentColors: string[];
    logoColors: string[];
    onSetLogoVariant:(variant: LogoColorVariant, color?: string) => void;
    addPresetColor:(color: string) => void;
}

interface IState {
}

export class LogoEditorLogoSettings extends React.Component<ILogoEditorLogoSettingsProps, IState> {
    constructor(props: ILogoEditorLogoSettingsProps) {
        super(props);
    }

    public render() {
        DebuggerInstance.log('LogoEditorLogoSettings');
        DebuggerInstance.log(this.props.logoObj);
        DebuggerInstance.log(this.props.variantsInfo);
        
        const variants = this.props.variantsInfo;
        const currVariant = this.props.logoObj.variant || LogoColorVariant.Original;

        return (
            <div className="logo-properties-root">
                <div className="variant-buttons">
                    <button
                        className={'variant-btn ' + (currVariant === LogoColorVariant.Original ? 'variant-selected' : '')}
                        onClick={() => this.props.onSetLogoVariant(LogoColorVariant.Original)}
                        data-tip={localization.editorLoc.logoEditorContent.toolTips.logoOriginalTip}
                        >
                        {localization.editorLoc.logoEditorContent.logoOriginal}
                    </button>
                    {variants.hasBlackVariant &&
                        <button
                            className={'variant-btn ' + (currVariant === LogoColorVariant.Black ? 'variant-selected' : '')}
                            onClick={() => this.props.onSetLogoVariant(LogoColorVariant.Black)}
                            data-tip={localization.editorLoc.logoEditorContent.toolTips.logoBlackTip}
                            >
                            {localization.editorLoc.logoEditorContent.logoBlack}
                        </button>
                    }
                    {variants.hasWhiteVariant &&
                        <button
                            className={'variant-btn ' + (currVariant === LogoColorVariant.White ? 'variant-selected' : '')}
                            onClick={() => this.props.onSetLogoVariant(LogoColorVariant.White)}
                            data-tip={localization.editorLoc.logoEditorContent.toolTips.logoWhiteTip}
                            >
                            
                            {localization.editorLoc.logoEditorContent.logoWhite}
                        </button>
                    }
                    <button
                        className={'variant-btn ' + (currVariant === LogoColorVariant.Custom ? 'variant-selected' : '')}
                        onClick={() => this.props.onSetLogoVariant(LogoColorVariant.Custom)}
                        data-tip={localization.editorLoc.logoEditorContent.toolTips.logoCustomTip}
                        >
                        {localization.editorLoc.logoEditorContent.logoCustom}
                    </button>
                    {(currVariant === LogoColorVariant.Custom) &&
                        <div className="picker-wrapper">
                            <FillPicker
                                selectedColor={this.props.customColor}
                                recentColors={this.props.recentColors}
                                logoColors={this.props.logoColors}
                                hint={localization.editorLoc.logoEditorContent.toolTips.rectFillColor}
                                onColorChanged={(color) => this.props.onSetLogoVariant(LogoColorVariant.Custom, color)}
                                addPresetColor={this.props.addPresetColor}
                            />
                        </div>
                    }
                </div>
                <ReactTooltip effect={'solid'} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-logo-settings.component.tsx